var _g, _g2, _g3, _g4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOveralRatingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 73,
    viewBox: "0 0 88 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_510_6501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.0218 38.8489C71.7366 37.2992 73.9392 37.2992 74.654 38.849L76.7724 43.4417C77.0638 44.0733 77.6623 44.5082 78.353 44.5901L83.3756 45.1856C85.0704 45.3865 85.751 47.4813 84.498 48.64L80.7847 52.074C80.274 52.5462 80.0454 53.2499 80.181 53.9321L81.1667 58.8929C81.4993 60.5668 79.7174 61.8614 78.2281 61.0278L73.8148 58.5574C73.2078 58.2177 72.468 58.2177 71.861 58.5574L67.4476 61.0278C65.9584 61.8614 64.1765 60.5668 64.5091 58.8929L65.4948 53.9321C65.6304 53.2499 65.4017 52.5462 64.8911 52.074L61.1778 48.64C59.9248 47.4813 60.6054 45.3865 62.3002 45.1856L67.3227 44.5901C68.0135 44.5082 68.612 44.0733 68.9034 43.4417L71.0218 38.8489Z",
    fill: "url(#paint0_linear_510_6501)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_510_6501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9222 45.7698C42.637 44.2201 44.8396 44.2201 45.5544 45.7698L47.6728 50.3626C47.9641 50.9942 48.5627 51.4291 49.2534 51.511L54.276 52.1065C55.9708 52.3074 56.6514 54.4022 55.3984 55.5609L51.6851 58.9949C51.1744 59.4671 50.9458 60.1708 51.0814 60.853L52.0671 65.8138C52.3997 67.4877 50.6177 68.7823 49.1285 67.9487L44.7152 65.4783C44.1082 65.1386 43.3683 65.1386 42.7614 65.4783L38.348 67.9487C36.8588 68.7823 35.0769 67.4877 35.4095 65.8138L36.3952 60.853C36.5308 60.1708 36.3021 59.4671 35.7915 58.9949L32.0782 55.5609C30.8252 54.4022 31.5058 52.3074 33.2006 52.1065L38.2231 51.511C38.9139 51.4291 39.5124 50.9942 39.8038 50.3626L41.9222 45.7698Z",
    fill: "url(#paint1_linear_510_6501)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_510_6501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.2644 6.06364C42.3267 3.70815 45.6715 3.70815 46.7338 6.06365L49.8706 13.0186C50.3021 13.9754 51.2022 14.6371 52.2442 14.7634L59.7937 15.6789C62.3157 15.9847 63.3397 19.091 61.494 20.8367L55.8221 26.2011C55.076 26.9067 54.7427 27.9448 54.9385 28.9529L56.4302 36.6308C56.9199 39.1513 54.2231 41.0821 51.9948 39.8065L45.4896 36.0824C44.5662 35.5538 43.432 35.5538 42.5086 36.0824L36.0034 39.8065C33.7751 41.0821 31.0783 39.1513 31.5679 36.6308L33.0596 28.9528C33.2555 27.9448 32.9222 26.9067 32.1761 26.2011L26.5042 20.8367C24.6585 19.091 25.6825 15.9847 28.2045 15.6789L35.754 14.7634C36.796 14.6371 37.6961 13.9754 38.1276 13.0186L41.2644 6.06364Z",
    fill: "url(#paint2_linear_510_6501)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_510_6501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3577 38.8489C14.0725 37.2992 16.2751 37.2992 16.9899 38.849L19.1084 43.4417C19.3997 44.0733 19.9983 44.5082 20.689 44.5901L25.7115 45.1856C27.4063 45.3865 28.087 47.4813 26.834 48.64L23.1207 52.074C22.61 52.5462 22.3814 53.2499 22.5169 53.9321L23.5026 58.8929C23.8352 60.5668 22.0533 61.8614 20.5641 61.0278L16.1507 58.5574C15.5438 58.2177 14.8039 58.2177 14.1969 58.5574L9.78359 61.0278C8.29436 61.8614 6.51244 60.5668 6.84505 58.8929L7.83075 53.9321C7.96631 53.2499 7.73767 52.5462 7.227 52.074L3.5137 48.64C2.2607 47.4813 2.94133 45.3865 4.63612 45.1856L9.65867 44.5901C10.3494 44.5082 10.948 44.0733 11.2393 43.4417L13.3577 38.8489Z",
    fill: "url(#paint3_linear_510_6501)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_510_6501",
    x: 60.5332,
    y: 37.6866,
    width: 24.6094,
    height: 23.6011,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_510_6501"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_510_6501",
    x: 31.4336,
    y: 44.6075,
    width: 24.6094,
    height: 23.6011,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_510_6501"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_510_6501",
    x: 25.5625,
    y: 4.297,
    width: 36.873,
    height: 35.9137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_510_6501"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_510_6501",
    x: 2.86914,
    y: 37.6866,
    width: 24.6094,
    height: 23.6011,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_510_6501"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_510_6501",
    x1: 81.5629,
    y1: 40.6861,
    x2: 61.9912,
    y2: 61.3157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0BF5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_510_6501",
    x1: 52.4633,
    y1: 47.607,
    x2: 32.8916,
    y2: 68.2366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0BF5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_510_6501",
    x1: 57.0102,
    y1: 8.80683,
    x2: 27.1329,
    y2: 39.5993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0BF5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_510_6501",
    x1: 26.5437,
    y1: 41.215,
    x2: 3.26917,
    y2: 62.9026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0BF5F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOveralRatingIcon);
export default __webpack_public_path__ + "static/media/OveralRatingIcon.e86342a74031bf2dd986842a7f455e1b.svg";
export { ForwardRef as ReactComponent };